import styled from 'styled-components';

export const TopCitiesNonProfitsWrap = styled.div`

    @media screen and (max-width: 1024px){ 
        padding-top: 128px;
    }
    @media screen and (max-width: 767px){ 
        padding-top: 114px;
    }

    .base-text {
        margin-bottom: 20px;
        padding-bottom: 0;
        &:last-child{
            margin-bottom: 0px;
        }   
    }
    &.search-header{
        display: none;
    }

    .page-main-heading{
        max-width: 500px;
    }

    .top-cities-banner{
        
        @media screen and (max-width: 1024px){ 
            padding-top: 60px;
        }

        .left_banner{
            
            @media screen and (max-width: 1024px){ 
                margin-bottom: 0;
            }
        }
    }
`;

export const TopCausesBannerSection = styled.section`

        @media screen and (max-width: 1024px){ 
            padding-top: 40px;
        }

        .causes-title{
            max-width: inherit;
        }
        
        .write-yellow-btn {
            padding: 11px 68px;
        }
        
        .row {
            align-items: center;
        }
        
        .search-header{
            display:none;
        }
        
        p {
            padding-bottom: 25px;
            &:last-child{
                padding-bottom: 0px;
            }
        }
`;



export const TopCausesSection = styled.section`

    .causes-title{
        max-width: inherit;
    }
    .write-yellow-btn {
        padding: 11px 68px;
    }
    .row {
        align-items: center;
    }
    .search-header{
        display:none;
    }
    p {
        padding-bottom: 25px;
        &:last-child{
            padding-bottom: 0px;
        }
    }
`;

export const TopCitiesSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 50px 0px 50px 0;
height: 100%;
    @media screen and (max-width: 767px){
        padding: 30px 0px;
    }

    @media screen and (max-width: 575px){
        padding: 20px 0px;
    }

    .top-city-count{
         
        column-count: 4;
        counter-reset: item-counter;
        
        @media screen and (max-width: 991px){
            column-count: 3;
        }
        
        @media screen and (max-width: 767px){
            column-count: 2;
        }
        
        @media screen and (max-width: 480px){
            column-count: 1;
        }
    }

    .loader-cities{
        .loading {
          top:70%;
        }
    }

`;

export const TopCitiesListBox = styled.div`
    width: 100%;
    max-width: 282px;
    margin-bottom: 20px;
    break-inside: avoid;

    @media screen and (max-width: 767px){
       max-width: inherit;
    }

    @media screen and (max-width: 991px){
        margin-bottom: 15px;
    }

    &:last-child{
        margin-bottom: 0px;
        @media screen and (max-width: 767px){
            margin-bottom: 15px;
        }
    }

    button{
        display: none;
    }
    h3{
        font-size: 18px;
        line-height: 26px;

        @media screen and (max-width: 991px){
            font-size: 16px;
            line-height: 24px;
        }
    }
    span{
        font-size: 18px;
        line-height: 26px;
    }
`;

export const CategoryCauseGroup = styled.div`
    width: 100%;
    background: #F1FEFF;
    padding: 50px 0px 0px;
    
    .browse-state-button-group{
        display: none;
    }
`;

export const TopCitiesImageBox = styled.div`
    width: 100%;
    border-radius: 20px;
    max-width: 242px;
    margin: 0 auto 20px;
    

    @media screen and (max-width: 991px){
        border-radius: 15px;
        margin: 0 auto 15px;
    }
    @media screen and (max-width: 767px){
        max-width: 200px;
    }

    &:last-child{
        margin-bottom: 0px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 15px;
    }  
`;

export const BrowseStateGroup = styled.div`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;

    .browse-name-dash,
    .browse-name-title,
    .browse-button-link,
    .browse-state-title{
        display: none;
    }
`;